import { Button, Icon } from '@symphony-ui/uitoolkit-components';
import { NewInfiniteTableContext } from 'components/custom-table/TableContext';
import * as React from 'react';
const CollapseCell = () => {
    const { resetRowExpansion } = React.useContext(NewInfiniteTableContext);
    const onClick = React.useCallback(() => {
        resetRowExpansion([]);
    }, [resetRowExpansion]);
    return (React.createElement("div", { style: { textAlign: 'center' } },
        React.createElement(Button, { iconButton: true, onClick: onClick },
            React.createElement(Icon, { iconName: "more-vertical" }))));
};
export default CollapseCell;
